import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CommonService } from '../../../../shared/common.service';
import * as CryptoJS from 'crypto-js';
import { BorrowingsService } from './service/borrowings.service';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';



@Component({
  selector: 'app-borrowings',
  templateUrl: './borrowings.component.html',
  styleUrls: ['./borrowings.component.scss']
})
export class BorrowingsComponent implements OnInit {

  borrowingsid: any;
  Amount: number;
  Amount_LY: number;
  isJump: any;
  CreateBorrowingsFormGroup: FormGroup;
  NormalRoutng: boolean;
  showBubbledata: any;
  constructor(public FormBuilder: FormBuilder, public BorrowingsService: BorrowingsService, public Router: Router, public commonService: CommonService, private sidenav: SideNavService) {

  }


  ngOnInit(): void {
    debugger
    this.commonService.getIncomeStatementsHeaders();
    this.isJump = localStorage.getItem('isJump');
    this.CreateBorrowingsForm();
    this.GetBorrowings();
      this.commonService.getNotesData();
      this.clearfield();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.CreateBorrowingsFormGroup.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.GetBorrowings_LY()
      }
    })
    if (localStorage.getItem("SubmitStatus") == "true")
      this.CreateBorrowingsFormGroup.disable()

  }

  CreateBorrowingsForm() {
    this.CreateBorrowingsFormGroup = this.FormBuilder.group({
      BorrowingsId: new FormControl(),
      WithinOneYear: new FormControl(),
      BetweenOneAndFiveYears: new FormControl(),
      OverFiveYears: new FormControl(),
      BorrowingsTotal: new FormControl({ value: '', disabled: true }), //BorrowingsTotal
      WithinOneYear_LY: new FormControl(),
      BetweenOneAndFiveYears_LY: new FormControl(),
      OverFiveYears_LY: new FormControl(),
      BorrowingsTotal_LY: new FormControl({ value: '', disabled: true }), //BorrowingsTotal_LY
      AdditionalInformation: new FormControl(),
      MatchingData: new FormControl(),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
    });
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.CreateBorrowingsFormGroup.reset()
      }
    })
  }

  GetBorrowings() {
    debugger;
    this.BorrowingsService.GetOneBorrowings(this.CreateBorrowingsFormGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      debugger
      this.CreateBorrowingsFormGroup.patchValue(data);
      this.borrowingsid = data.BorrowingsId;
      this.CreateBorrowingsFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }
  GetBorrowings_LY() {
    debugger;
    this.BorrowingsService.GetOneBorrowings_LY(this.CreateBorrowingsFormGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      this.showBubbledata = data;
      this.CreateBorrowingsFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }

  On_Next() {
    debugger;
    if (this.On_NextBalancesheetValidaton()) {
    if (this.borrowingsid != null && this.borrowingsid != "")
      this.CreateBorrowingsFormGroup.controls["APPeriodId"].setValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    this.BorrowingsService.SaveBorrowings(this.CreateBorrowingsFormGroup.getRawValue()).subscribe(data => {
      this.CreateBorrowingsFormGroup.markAsPristine();
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Borrowings", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.Router.navigate(['/notes'])
      else if (nextPage == "borrowings") {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.Router.navigate([nextPage]);
      }
      else {
        this.Router.navigate([nextPage]);
      }
    })
     }
  }

  On_Back() {
    debugger;
    this.CreateBorrowingsFormGroup.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.Router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Borrowings", this.commonService.NotesList)
      this.Router.navigate([backpage]);
    }
  }


  Calculations() {
    debugger;
    var total1 = +this.CreateBorrowingsFormGroup.controls['WithinOneYear'].value + +this.CreateBorrowingsFormGroup.controls['BetweenOneAndFiveYears'].value
      + +this.CreateBorrowingsFormGroup.controls['OverFiveYears'].value;
    var total2 = +this.CreateBorrowingsFormGroup.controls['WithinOneYear_LY'].value + +this.CreateBorrowingsFormGroup.controls['BetweenOneAndFiveYears_LY'].value
      + +this.CreateBorrowingsFormGroup.controls['OverFiveYears_LY'].value;
    this.CreateBorrowingsFormGroup.controls['BorrowingsTotal'].setValue(total1 == 0 ? '' : total1);
    this.CreateBorrowingsFormGroup.controls['BorrowingsTotal_LY'].setValue(total2 == 0 ? '' : total2);


  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.CreateBorrowingsFormGroup.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight:bold'>You have unsaved data.</span> <br><span> Do you want to save your changes before leaving? </span> ",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          this.On_Next();
          return true;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.Router.navigate(['/business']);

  }
  On_NextBalancesheetValidaton() {
    debugger;
    if (this.commonService.AccountTemplateId == 11) {
      if (this.commonService.showControl == true) {
        if (+this.CreateBorrowingsFormGroup.controls['BorrowingsTotal'].value != +this.CreateBorrowingsFormGroup.controls['MatchingData'].value.Item1) {
          Swal.fire("Andica Accounts Production", "Borrowings value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Balance sheet account for the year " + this.commonService.StartYear + ".", 'warning');
          return false;
        }
        else if (+this.CreateBorrowingsFormGroup.controls['BorrowingsTotal_LY'].value != +this.CreateBorrowingsFormGroup.controls['MatchingData'].value.Item2) {
          Swal.fire("Andica Accounts Production", "Borrowings value for the year " + this.commonService.LastYear + " must tally with the amount that appears in the Balance sheet account for the year " + this.commonService.LastYear + ".", 'warning');
          return false;
        }
        else
          return true
      }
      else {
        if (+this.CreateBorrowingsFormGroup.controls['BorrowingsTotal'].value != +this.CreateBorrowingsFormGroup.controls['MatchingData'].value.Item1) {
          Swal.fire("Andica Accounts Production", "Borrowings value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Balance sheet account for the year " + this.commonService.StartYear + ".", 'warning');
          return false;
        }
        else
          return true
      }
    }
    else {
      return true
    }
  }


}
